import axios from './auth-v2-axios'

export function verifyUserCode(code: string) {
  return axios.get(`v2/user/verify_code/${code}`)
}
